
export enum Criterions {
  Infrastructure = 'Infrastructure',
  Personnel = 'Personnel',
  Effectiveness = 'Effectiveness',
}
